
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('example', require('./components/ExampleComponent.vue'));
Vue.component('select2', require('./components/Select2.vue'));
Vue.component('publisher-editor', require('./components/PublisherEditorComponent.vue'));
Vue.component('publisher-related-filter', require('./components/PublisherRelatedFilterComponent.vue'));
Vue.component('chart', require('./components/Chart.vue')); // Vue.component('chart', () => System.import('./components/Chart.vue'));
Vue.component('pre-loader', require('./components/PreLoader.vue'));
Vue.prototype.trans = (key) => {
    return _.get(window.trans, key, key);
};

// To make Pace works on Ajax calls
$(document).ajaxStart(function() { Pace.restart(); });
// Ajax calls should always have the CSRF token attached to them, otherwise they won't work
$(function(){
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
});


// WEBPACK FOOTER //
// ./resources/assets/js/app.js